// extracted by mini-css-extract-plugin
export default {"resultContainer":"results_resultContainer__hLraE","input-details":"results_input-details__jZLfl","calculationResults":"results_calculationResults__LLu6H"};